import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@core/ui/button/button.module';
import { ThemeSwitcherComponent } from './theme-switcher.component';

@NgModule({
  declarations: [ThemeSwitcherComponent],
  imports: [CommonModule, ButtonModule],
  exports: [ThemeSwitcherComponent],
})
export class ThemeSwitcherModule {}
